import { sireSubTabs } from './tabNames';

const calculateActiveClass = (
    isSire, hasWeatherbys, isSubTabSelected, tab
) => {
    if (!isSire || !isSubTabSelected) {
        return 'ui-tabs__tab_selected';
    }

    return `ui-tabs__tab_selected ${
        (hasWeatherbys && (!tab || sireSubTabs.stallionDetails.includes(tab))) ?
            'weatherbys' : 'dark'
    }`;
};

export default calculateActiveClass;



// WEBPACK FOOTER //
// ./src/js/shared/nav/helpers/calculateActiveClass.js